import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.manual');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-manual',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.manual/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.manual-layout {
  min-height: calc(100vh - 136px);
}

.manual-content {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 24px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 136px);
  min-height: 620px;
}
.manual-content .manual-chapter-header {
  align-items: center;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex: 0 0 72px;
  gap: 16px;
  height: 72px;
  justify-content: space-between;
  padding: 14px 24px;
}
.manual-content .manual-chapter-tabs {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  overflow-x: auto;
  padding: 12px 24px;
  scrollbar-gutter: stable;
  white-space: nowrap;
}
.manual-content .manual-chapter-tab {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  border-radius: 8px;
  color: #475569;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  height: 34px;
  justify-content: center;
  line-height: 1;
  padding: 0 12px;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}
.manual-content .manual-chapter-tab:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}
.manual-content .manual-chapter-tab-active {
  background: #f0f9ff;
  border-color: #7dd3fc;
  color: #0369a1;
}
.manual-content .manual-track {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  transition: transform 280ms ease;
  width: 100%;
  will-change: transform;
}
.manual-content .manual-chapter {
  flex: 0 0 100%;
  height: 100%;
  min-width: 100%;
  overflow-y: auto;
  padding: 32px 24px 96px;
  scrollbar-gutter: stable;
}
.manual-content .manual-chapter > * {
  margin-left: auto;
  margin-right: auto;
  max-width: 64rem;
}
.manual-content .manual-nav-button,
.manual-content .manual-floating-button {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #334155;
  display: inline-flex;
  justify-content: center;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, opacity 160ms ease;
}
.manual-content .manual-nav-button:hover:not(:disabled),
.manual-content .manual-floating-button:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #0f172a;
}
.manual-content .manual-nav-button:disabled,
.manual-content .manual-floating-button:disabled {
  cursor: default;
  opacity: 0.38;
}
.manual-content .manual-nav-button {
  height: 36px;
  width: 36px;
}
.manual-content .manual-nav-button-primary {
  background: #f0f9ff;
  border-color: #7dd3fc;
  color: #0369a1;
}
.manual-content .manual-nav-button-primary:hover:not(:disabled) {
  background: #e0f2fe;
  border-color: #38bdf8;
  color: #075985;
}
.manual-content .manual-floating-button {
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
  height: 44px;
  position: absolute;
  top: calc(72px + (100% - 72px) / 2);
  transform: translateY(-50%);
  width: 44px;
  z-index: 10;
}
.manual-content .manual-floating-button:disabled {
  opacity: 0;
  pointer-events: none;
}
.manual-content .manual-floating-button-left {
  left: 16px;
}
.manual-content .manual-floating-button-right {
  right: 16px;
}
.manual-content h2 {
  scroll-margin-top: 80px;
}
.manual-content h3 {
  scroll-margin-top: 80px;
}

@media (min-width: 1024px) {
  .manual-content .manual-chapter-header {
    padding-left: 32px;
    padding-right: 32px;
  }
  .manual-content .manual-chapter-tabs {
    padding-left: 32px;
    padding-right: 32px;
  }
  .manual-content .manual-chapter {
    padding: 32px 48px 112px;
  }
  .manual-content .manual-floating-button-left {
    left: 24px;
  }
  .manual-content .manual-floating-button-right {
    right: 24px;
  }
}
@media (max-width: 767px) {
  .manual-layout {
    min-height: calc(100vh - 112px);
  }
  .manual-content {
    border-radius: 18px;
    height: calc(100vh - 112px);
    min-height: 560px;
  }
  .manual-content .manual-chapter-header {
    flex-basis: 64px;
    height: 64px;
    padding: 10px 16px;
  }
  .manual-content .manual-chapter-tabs {
    gap: 6px;
    padding: 10px 16px;
  }
  .manual-content .manual-chapter-tab {
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .manual-content .manual-chapter {
    padding: 24px 16px 80px;
  }
  .manual-content .manual-floating-button {
    display: none;
  }
}`],
})
export class PageManualComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public activeSection: string = 'overview';
    public activeSectionIndex: number = 0;
    public prototypeInfo: any = null;

    public sections = [
        { id: 'overview', label: '서비스 소개', icon: 'home' },
        { id: 'quick-start', label: '모드 선택 가이드', icon: 'analysis' },
        { id: 'model-registration', label: '모델 추가 방법', icon: 'pipeline' },
        { id: 'training-guide', label: '학습 방법', icon: 'pipeline' },
        { id: 'dashboard', label: '화면 표시 설정', icon: 'analysis' },
        { id: 'upload', label: '업로드 모드', icon: 'upload' },
        { id: 'upload-guide', label: '업로드 파일/라벨 가이드', icon: 'upload' },
        { id: 'webcam', label: '실시간 모드', icon: 'webcam' },
        { id: 'result', label: '분석 결과 보기', icon: 'result' },
        { id: 'feedback', label: '피드백 / 재학습', icon: 'feedback' },
        { id: 'alert', label: '위험 알림', icon: 'alert' },
        { id: 'pipeline', label: 'AI 파이프라인', icon: 'pipeline' },
        { id: 'model-training', label: '관리자 학습 재현', icon: 'pipeline' },
        { id: 'faq', label: '자주 묻는 질문', icon: 'faq' },
    ];

    public async ngOnInit() {
        await this.service.init(this);
        await this.loadPrototypeInfo();
        await this.service.render();
    }

    public async loadPrototypeInfo() {
        try {
            const { code, data } = await wiz.call('prototype_info');
            if (code === 200) this.prototypeInfo = data || null;
        } catch (e) {
            this.prototypeInfo = null;
        }
    }

    public scrollTo(sectionId: string) {
        this.setSection(sectionId);
    }

    public setSection(sectionId: string) {
        const index = this.sections.findIndex((section: any) => section.id === sectionId);
        if (index < 0) return;
        this.activeSectionIndex = index;
        this.activeSection = sectionId;
        setTimeout(() => {
            const el = document.getElementById('section-' + sectionId);
            if (el) el.scrollTop = 0;
        });
        this.service.render();
    }

    public goPrevious() {
        if (!this.hasPreviousSection()) return;
        this.setSection(this.sections[this.activeSectionIndex - 1].id);
    }

    public goNext() {
        if (!this.hasNextSection()) return;
        this.setSection(this.sections[this.activeSectionIndex + 1].id);
    }

    public hasPreviousSection(): boolean {
        return this.activeSectionIndex > 0;
    }

    public hasNextSection(): boolean {
        return this.activeSectionIndex < this.sections.length - 1;
    }

    public currentSection(): any {
        return this.sections[this.activeSectionIndex] || this.sections[0];
    }

    public chapterTransform(): string {
        return `translateX(-${this.activeSectionIndex * 100}%)`;
    }

    public sectionPositionLabel(): string {
        return `${this.activeSectionIndex + 1} / ${this.sections.length}`;
    }

    public goMain() {
        this.service.href('/');
    }

    public modelTrainingStats(): any[] {
        const stats = this.prototypeInfo?.dataset_summary?.model_training_stats;
        return Array.isArray(stats) ? stats : [];
    }

    public modelTrainingStat(key: string): any {
        return this.modelTrainingStats().find((item: any) => item?.key === key) || {};
    }

    public modelMetricText(item: any): string {
        const bits = [];
        if (item?.algorithm) bits.push(String(item.algorithm));
        const f1 = Number(item?.macro_f1 ?? item?.f1 ?? 0);
        const acc = Number(item?.accuracy ?? 0);
        const recall = Number(item?.recall ?? 0);
        const precision = Number(item?.precision ?? 0);
        if (Number.isFinite(f1) && f1 > 0) bits.push(`F1 ${(f1 * 100).toFixed(1)}%`);
        if (Number.isFinite(acc) && acc > 0) bits.push(`Acc ${(acc * 100).toFixed(1)}%`);
        if (Number.isFinite(recall) && recall > 0) bits.push(`Recall ${(recall * 100).toFixed(1)}%`);
        if (Number.isFinite(precision) && precision > 0) bits.push(`Precision ${(precision * 100).toFixed(1)}%`);
        return bits.join(' · ') || '-';
    }

    public totalTrainingSamples(): number {
        const total = Number(this.prototypeInfo?.dataset_summary?.total_training_samples || 0);
        if (Number.isFinite(total) && total > 0) return total;
        return this.modelTrainingStats().reduce((sum: number, item: any) => sum + Number(item?.sample_count || 0), 0);
    }
}

export default PageManualComponent;